import {
	ROUTE_PAGE_CATALOGUE_EXPORTS,
	ROUTE_PAGE_COORGANIZATIONS,
	ROUTE_PAGE_ENTERSOFT_TRANSFER,
	ROUTE_PAGE_EXHIBITION,
	ROUTE_PAGE_GENERAL_REPORTS,
	ROUTE_PAGE_HOME
} from "../../routers/routes";
import { Permissions } from "../constants";
import { getRouteUrl } from "../getRouteUrl";
import { normalizeGreek } from "../normalizeGreek";

export const exhibitorMenu = ({
								  id,
								  t,
								  hasExhibitorScanning,
								  displayServiceProvidersToExhibitor,
								  displayContractorsToExhibitor,
								  displayPartnersToExhibitor,
								  displayExhibitorKitAndAddsToExhibitor,
								  displayVisitorsToExhibitor,
								  displayFreeAdvertisementToExhibitor,
								  faqs
							  }) => ([
	{
		icon: 'DashboardOutlined',
		id: 'group-dashboard',
		title: '',
		type: 'group',
		permissions: [Permissions.BeExhibitor],
		children: [
			{
				url: getRouteUrl(ROUTE_PAGE_EXHIBITION, { id: id }, {
					section: "profile", subSection: "catalog"
				}), title: t("Catalogue"), icon: 'ListIcon', // hoverIcon: HomeIcon,
				hoverMessage: t("Catalogue"), id: 'catalogue', type: 'item', breadcrumbs: false,
			},
			(displayFreeAdvertisementToExhibitor ? {
				url: getRouteUrl(ROUTE_PAGE_EXHIBITION, { id: id }, {
					section: "profile", subSection: "free-advertisement"
				}),
				title: t("Free Catalogue Advertisement"),
				icon: 'FreeAdvertisementIcon', // hoverIcon: HomeIcon,
				hoverMessage: t("Free Catalogue Advertisement"),
				id: 'free-advertisement',
				type: 'item',
				breadcrumbs: false,
			} : {})],
	},
	{
		icon: 'DashboardOutlined',
		id: 'group2',
		title: '',
		type: 'group',
		permissions: [Permissions.BeExhibitor],
		children: [
			(displayVisitorsToExhibitor ? {
				url: getRouteUrl(ROUTE_PAGE_EXHIBITION, { id: id }, {
					section: "profile", subSection: "visitors"
				}), title: t("Invitation"), icon: 'MailIcon', // hoverIcon: HomeIcon,
				hoverMessage: t("Invitation"), id: 'profile-visitors', type: 'item', breadcrumbs: false,
			} : {}), (displayExhibitorKitAndAddsToExhibitor ? {
				url: getRouteUrl(ROUTE_PAGE_EXHIBITION, { id: id }, {
					section: "profile", subSection: "kit"
				}), title: normalizeGreek(t("Marketing Kit - Upload Logo")), icon: 'ImageIcon', // hoverIcon: HomeIcon,
				hoverMessage: normalizeGreek(t("Marketing Kit")), id: 'marketing-kit', type: 'item', breadcrumbs: false,
			} : {}), (displayPartnersToExhibitor ? {
				url: getRouteUrl(ROUTE_PAGE_EXHIBITION, {
					id: id,
				}, { section: "profile" }),
				title: t("Entry Cards (Badges) - Exhibitors"),
				icon: 'UserCardIcon', // hoverIcon: HomeIcon,
				hoverMessage: t("Entry Cards (Badges) - Exhibitors"),
				id: 'entry-cards-exhibitors',
				type: 'item',
				breadcrumbs: false,
			} : {}), (displayServiceProvidersToExhibitor ? {
				url: getRouteUrl(ROUTE_PAGE_EXHIBITION, {
					id: id,
				}, { section: "profile", subSection: "serviceProviders" }),
				title: t("Entry Cards (Badges) - Service Providers"),
				icon: 'UserCardIcon', // hoverIcon: HomeIcon,
				hoverMessage: t("Entry Cards (Badges) - Service Providers"),
				id: 'entry-cards-providers',
				type: 'item',
				breadcrumbs: false,
			} : {}), (displayContractorsToExhibitor ? {
				url: getRouteUrl(ROUTE_PAGE_EXHIBITION, {
					id: id,
				}, { section: "profile", subSection: "contractors" }),
				title: t("Entry Cards (Badges) - Contractors"),
				icon: 'UserCardIcon', // hoverIcon: HomeIcon,
				hoverMessage: t("Entry Cards (Badges) - Contractors"),
				id: 'entry-cards-contractors',
				type: 'item',
				breadcrumbs: false,
			} : {}), (hasExhibitorScanning ? {
				url: getRouteUrl(ROUTE_PAGE_EXHIBITION, {
					id: id,
				}, { section: "profile", subSection: "scanVisitors" }),
				title: t("Scan Visitors"),
				icon: 'QrCodeIcon',
				isNew: true,
				hoverMessage: t("Scan Visitors"),
				id: 'visitor-scan',
				type: 'item',
				breadcrumbs: false,
			} : {}), (hasExhibitorScanning ? {
				url: getRouteUrl(ROUTE_PAGE_EXHIBITION, {
					id: id,
				}, { section: "profile", subSection: "myVisitors" }), title: t("My Visitors"), icon: 'UserCheckIcon', // ListAlt
				// hoverIcon: HomeIcon,
				hoverMessage: t("My Visitors"), id: 'my-visitors', type: 'item', breadcrumbs: false, isNew: true,
			} : {})]
	}
])

export const organizerMenu = (t) => ([
	{
		icon: 'DashboardOutlined',
		id: 'group-dashboard',
		title: '',
		type: 'group',
		permissions: [Permissions.BeOrganizer],
		children: [
			{
				url: getRouteUrl(ROUTE_PAGE_HOME),
				title: t("Home"),
				icon: 'HomeIcon',
				// hoverIcon: HomeIcon,
				hoverMessage: t("Home"),
				id: 'home',
				type: 'item',
				breadcrumbs: false,
			},
			{
				url: getRouteUrl(ROUTE_PAGE_ENTERSOFT_TRANSFER),
				title: t("EnterSoft Transfer"),
				icon: 'MoveUp',
				// hoverIcon: HomeIcon,
				hoverMessage: t("EnterSoft Transfer"),
				id: 'entersoft-transfer',
				type: 'item',
				breadcrumbs: false,
			},
			{
				url: getRouteUrl(ROUTE_PAGE_COORGANIZATIONS),
				title: t("Coorganizations"),
				icon: 'SettingsApplications',
				// hoverIcon: HomeIcon,
				hoverMessage: t("Coorganizations"),
				id: 'coorganizations',
				type: 'item',
				breadcrumbs: false,
			},
			{
				url: getRouteUrl(ROUTE_PAGE_CATALOGUE_EXPORTS),
				title: t("Catalogue Exports"),
				icon: 'ImportExport',
				// hoverIcon: HomeIcon,
				hoverMessage: t("Catalogue Exports"),
				id: 'catalogue-exports',
				type: 'item',
				breadcrumbs: false,
			},
			{
				url: getRouteUrl(ROUTE_PAGE_GENERAL_REPORTS),
				title: t("General Reports"),
				icon: 'Analytics',
				// hoverIcon: HomeIcon,
				hoverMessage: t("General Reports"),
				id: 'general-reports',
				type: 'item',
				breadcrumbs: false,
				permissions: [Permissions.SeeReports],
			},
		]
	}
])